import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { post } from 'aws-amplify/api';
import '../styles/management.css';

function InvitationConfirmationScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedGuests, setSelectedGuests] = useState(
    location.state?.selectedGuests || []
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  
  const handleGuestPreferenceChange = (guestId, field, value) => {
    setSelectedGuests(guests => 
      guests.map(guest => 
        guest.id === guestId ? { ...guest, [field]: value } : guest
      )
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await post({
        apiName: 'events',
        path: `/invitations/${location.state.eventId}`,
        options: {
          body: { guests: selectedGuests }
        }
      });
      
      if (response.body) {
        navigate(`/invitations/${location.state.eventId}`);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="content">
      <h1 className="content__heading">Confirm Invitation Details</h1>
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <table className="table">
          <thead>
            <tr>
              <th>Guest Name</th>
              <th>Phone</th>
              <th>Send SMS</th>
              <th>Email</th>
              <th>Send Email</th>
            </tr>
          </thead>
          <tbody>
            {selectedGuests.map(guest => (
              <tr key={guest.id}>
                <td>{guest.firstName || ''} ({guest.shortName || ''}) {guest.lastName || ''}</td>
                <td>{guest.phone}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={guest.sendSMS}
                    onChange={(e) => handleGuestPreferenceChange(guest.id, 'sendSMS', e.target.checked)}
                  />
                </td>
                <td>{guest.email}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={guest.sendEmail}
                    onChange={(e) => handleGuestPreferenceChange(guest.id, 'sendEmail', e.target.checked)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className="button-group">
          <button
            type="button"
            className="button button--secondary"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
          <button
            type="submit"
            className="button button--primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Creating...' : 'Confirm & Create Invitation'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default InvitationConfirmationScreen;